module.exports = __webpack_public_path__ + "static/media/example-work02.bae7c8a1.jpg";